const exportStaffTable = async (token: string, year: number) => {
	const response = await fetch(`${process.env.REACT_APP_BASE_API}/emails/export-staff-table`, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			Authorization: `Bearer ${token}`
		},
		body: JSON.stringify({ year })
	});

	return response.json();
};

export default exportStaffTable;
